const isArraysEqual = (a, b) => {
  return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => b.includes(val));
}

const findObjectByKeyValue = (array, value, key) => {
  return array.find(function(obj){
    return obj[key] === value
  })
}

const hasIntersection = (A, B) => {
  const setA = new Set(A);
  return B.some(item => setA.has(item));
};

export {
  isArraysEqual,
  findObjectByKeyValue,
  hasIntersection
};


// WEBPACK FOOTER //
// ./src/helpers/array_helpers.js